/**
 * signature-label.ts — German labels + tone for the eight register signature codes.
 *
 * The api sends the parser code on the wire (einzel, kollektiv_2, …); the web owns the German
 * wording so the label map is not duplicated server-side. An unknown/legacy free-text code
 * (0138 backfilled whatever company_master held) falls back to the code verbatim rather than
 * showing nothing.
 *
 * For the CUSTOMER-firm Zeichnungsberechtigte card only — unrelated to the broker signatories.
 */

export const SIGNATURE_LABEL: Record<string, string> = {
  einzel: 'Einzelunterschrift',
  kollektiv_2: 'Kollektivunterschrift zu zweien',
  kollektiv_3: 'Kollektivunterschrift zu dreien',
  prokura_einzel: 'Einzelprokura',
  prokura_kollektiv_2: 'Kollektivprokura zu zweien',
  prokura_kollektiv_3: 'Kollektivprokura zu dreien',
  none: 'ohne Zeichnungsberechtigung',
  other: 'Zeichnungsberechtigung (Details im Register)',
};

export function signatureLabel(code: string): string {
  return SIGNATURE_LABEL[code] ?? code;
}

/** Badge variant per code. 'ok'/'info'/'neutral' are all valid Badge variants. */
export const SIGNATURE_TONE: Record<string, 'ok' | 'info' | 'neutral'> = {
  einzel: 'ok',
  kollektiv_2: 'ok',
  kollektiv_3: 'ok',
  prokura_einzel: 'info',
  prokura_kollektiv_2: 'info',
  prokura_kollektiv_3: 'info',
  none: 'neutral',
  other: 'neutral',
};

/** Tone for a code, defaulting to neutral for unknown/legacy values. */
export function signatureTone(code: string): 'ok' | 'info' | 'neutral' {
  return SIGNATURE_TONE[code] ?? 'neutral';
}
